import { api } from "../../utills/api";

export const depositApi = api.injectEndpoints({
  endpoints: (build) => ({
    getDeposit: build.mutation<{ data: any }, any>({
      query: (params) => ({
        url: "/deposit",
        body: params,
        method: "POST",
      }),
    }),
    getMerchantDeposit: build.mutation<any, any>({
      query: (params) => ({
        url: "/merchant/deposit",
        body: params,
        method: "POST",
      }),
    }),
  }),
});

export const { useGetDepositMutation, useGetMerchantDepositMutation } =
  depositApi;
export const {
  endpoints: { getDeposit, getMerchantDeposit },
} = depositApi;
